import {IconProps} from '../icon-props-interface';

const IconAlignLeft = ({ color = 'var(--color-primary-2)' }: IconProps) => (
	<div className="icon-block">
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9 1.00391C9 1.55703 8.55313 2.00391 8 2.00391H1C0.446875 2.00391 0 1.55703 0 1.00391C0 0.450781 0.446875 0.00390625 1 0.00390625H8C8.55313 0.00390625 9 0.450781 9 1.00391ZM9 9.00391C9 9.55703 8.55313 10.0039 8 10.0039H1C0.446875 10.0039 0 9.55703 0 9.00391C0 8.45078 0.446875 8.00391 1 8.00391H8C8.55313 8.00391 9 8.45078 9 9.00391ZM0 5.00391C0 4.45078 0.446875 4.00391 1 4.00391H13C13.5531 4.00391 14 4.45078 14 5.00391C14 5.55703 13.5531 6.00391 13 6.00391H1C0.446875 6.00391 0 5.55703 0 5.00391ZM14 13.0039C14 13.557 13.5531 14.0039 13 14.0039H1C0.446875 14.0039 0 13.557 0 13.0039C0 12.4508 0.446875 12.0039 1 12.0039H13C13.5531 12.0039 14 12.4508 14 13.0039Z"
				fill={color}
			/>
		</svg>
	</div>
);

export default IconAlignLeft;
